
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.135 4.85L0 .727.73 0 4.5 3.756 8.27 0 9 .728 4.865 4.85a.518.518 0 01-.73 0z","fill":"currentColor"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./public/dist/img/svg/select-arrow.svg